import { ABBY_AB_STORAGE_PREFIX, ABBY_FF_STORAGE_PREFIX, ABBY_RC_STORAGE_PREFIX } from './chunk-2HPJHXZH.mjs';

// src/shared/helpers.ts
function getABStorageKey(projectId, testName) {
  return `${ABBY_AB_STORAGE_PREFIX}${projectId}_${testName}`;
}
function getFFStorageKey(projectId, flagName) {
  return `${ABBY_FF_STORAGE_PREFIX}${projectId}_${flagName}`;
}
function getRCStorageKey(projectId, remoteConfigName) {
  return `${ABBY_RC_STORAGE_PREFIX}${projectId}_${remoteConfigName}`;
}
function assertUnreachable(x) {
  throw new Error("Reached unreachable code");
}
function remoteConfigStringToType({
  stringifiedValue,
  remoteConfigType
}) {
  switch (remoteConfigType) {
    case "String":
      return stringifiedValue;
    case "Number":
      return parseInt(stringifiedValue, 10);
    case "JSON":
      return JSON.parse(stringifiedValue);
    default:
      assertUnreachable();
  }
}
function getDefaultRemoteConfigValue(remoteConfigType) {
  switch (remoteConfigType) {
    case "String":
      return "";
    case "Number":
      return 0;
    case "JSON":
      return {};
    default:
      assertUnreachable();
  }
}
function stringifyRemoteConfigValue(value) {
  switch (typeof value) {
    case "number":
      return value.toString();
    case "string":
      return value;
    case "object":
      return JSON.stringify(value);
    default:
      assertUnreachable();
  }
}
var getUseFeatureFlagRegex = (flagName) => new RegExp(`useFeatureFlag\\s*\\(\\s*['"\`]${flagName}['"\`]\\s*\\)`);

export { assertUnreachable, getABStorageKey, getDefaultRemoteConfigValue, getFFStorageKey, getRCStorageKey, getUseFeatureFlagRegex, remoteConfigStringToType, stringifyRemoteConfigValue };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-HK6BSHXQ.mjs.map